import { SECURED_ONE_CARD, CARD_REWARDS_MVP, CARD_TRIPLE_CASH_REWARDS, CARD_UNLIMITED_CASH_REWARDS, CARD_REWARDS_ELITE, CARD_TRIPLE_CASH_REWARDS_ZERO, CARD_REWARDS_ELITE_EARLY_PAY, CARD_LIFE_REWARDS, CARD_TRAVEL_CASH_REWARDS, LENDING_TREE_GROW, CARD_LIFE_REWARDS_ZERO, CARD_CREDIT_BUILDER, CARD_MYFIVE_CASH_REWARDS, CARD_MYFIVE_CASH_REWARDS_V2, CARD_CASH_REWARDS_WITH_AUTOPAY, CARD_REWARDS_MVP_WITH_ANNUAL_FEE, CARD_TRIPLE_CASH_REWARDS_WITH_ANNUAL_FEE, CARD_UNLIMITED_CASH_REWARDS_WITH_ANNUAL_FEE, CARD_REWARDS_ELITE_EARLY_PAY_WITH_ANNUAL_FEE, CARD_LIFE_REWARDS_WITH_ANNUAL_FEE, CARD_MYFIVE_CASH_REWARDS_WITH_ANNUAL_FEE, CARD_MYFIVE_CASH_REWARDS_V2_WITH_ANNUAL_FEE, CARD_CASH_REWARDS_WITH_AUTOPAY_WITH_ANNUAL_FEE, ONE_CARD_SELECT, CARD_TRAVEL_CASH_BACK_REWARDS_SELECT, CARD_REWARDS_ELITE_WITH_ANNUAL_FEE } from '../../constants/program-definition-code';
import { ONE_CARD_PROGRAM_DEFINITION_CODES } from '../../constants/pcl/program-definition-code';
const CARD = {
  DEFAULT: 'DEFAULT'
};
const CARD_DEFINITION = {
  ONE_CARD_SELECT: {
    codes: [ONE_CARD_SELECT],
    name: 'Upgrade OneCard Select',
    article: 'an'
  },
  SECURED_ONE_CARD: {
    codes: [SECURED_ONE_CARD],
    name: 'Upgrade OneCard',
    shortName: 'Secured OneCard',
    article: 'an'
  },
  ONE_CARD: {
    codes: ONE_CARD_PROGRAM_DEFINITION_CODES,
    name: 'Upgrade OneCard',
    shortName: 'OneCard',
    article: 'an'
  },
  REWARDS_MVP_CARD: {
    codes: [CARD_REWARDS_MVP],
    name: 'Upgrade Cash Rewards Card',
    shortName: 'Cash Rewards',
    article: 'an',
    legalDefinition: CARD.DEFAULT
  },
  REWARDS_MVP_CARD_WITH_ANNUAL_FEE: {
    codes: [CARD_REWARDS_MVP_WITH_ANNUAL_FEE],
    name: 'Upgrade Cash Rewards Select Card',
    shortName: 'Cash Rewards Select',
    article: 'an',
    legalDefinition: CARD.DEFAULT
  },
  TRIPLE_CASH_REWARDS_CARD: {
    codes: [CARD_TRIPLE_CASH_REWARDS, CARD_TRIPLE_CASH_REWARDS_ZERO],
    name: 'Upgrade Triple Cash Rewards Card',
    shortName: 'Triple Cash Rewards',
    article: 'an',
    legalDefinition: CARD.DEFAULT
  },
  TRIPLE_CASH_REWARDS_CARD_WITH_ANNUAL_FEE: {
    codes: [CARD_TRIPLE_CASH_REWARDS_WITH_ANNUAL_FEE],
    name: 'Upgrade Triple Cash Rewards Select Card',
    shortName: 'Triple Cash Rewards Select',
    article: 'an',
    legalDefinition: CARD.DEFAULT
  },
  UNLIMITED_CASH_REWARDS_CARD: {
    codes: [CARD_UNLIMITED_CASH_REWARDS],
    name: 'Upgrade Unlimited Cash Rewards Card',
    shortName: 'Unlimited Cash Rewards',
    article: 'an',
    legalDefinition: CARD.DEFAULT
  },
  UNLIMITED_CASH_REWARDS_CARD_WITH_ANNUAL_FEE: {
    codes: [CARD_UNLIMITED_CASH_REWARDS_WITH_ANNUAL_FEE],
    name: 'Upgrade Unlimited Cash Rewards Select Card',
    shortName: 'Unlimited Cash Rewards Select',
    article: 'an',
    legalDefinition: CARD.DEFAULT
  },
  REWARDS_ELITE_CARD: {
    codes: [CARD_REWARDS_ELITE, CARD_REWARDS_ELITE_EARLY_PAY],
    name: 'Upgrade Cash Rewards Elite Card',
    shortName: 'Cash Rewards Elite',
    article: 'an',
    legalDefinition: CARD.DEFAULT
  },
  REWARDS_ELITE_CARD_WITH_ANNUAL_FEE: {
    codes: [CARD_REWARDS_ELITE_WITH_ANNUAL_FEE, CARD_REWARDS_ELITE_EARLY_PAY_WITH_ANNUAL_FEE],
    name: 'Upgrade Cash Rewards Elite Select Card',
    shortName: 'Cash Rewards Elite Select',
    article: 'an',
    legalDefinition: CARD.DEFAULT
  },
  LIFE_REWARDS_CARD: {
    codes: [CARD_LIFE_REWARDS, CARD_LIFE_REWARDS_ZERO],
    name: 'Upgrade Life Rewards Card',
    shortName: 'Life Rewards',
    article: 'an',
    legalDefinition: CARD.DEFAULT
  },
  LIFE_REWARDS_CARD_WITH_ANNUAL_FEE: {
    codes: [CARD_LIFE_REWARDS_WITH_ANNUAL_FEE],
    name: 'Upgrade Life Rewards Select Card',
    shortName: 'Life Rewards Select',
    article: 'an',
    legalDefinition: CARD.DEFAULT
  },
  TRAVEL_CASH_REWARDS_CARD: {
    codes: [CARD_TRAVEL_CASH_REWARDS],
    name: 'Upgrade Travel Rewards Card',
    shortName: 'Travel Rewards',
    article: 'an',
    legalDefinition: CARD.DEFAULT
  },
  TRAVEL_CASH_REWARDS_CARD_WITH_ANNUAL_FEE: {
    codes: [CARD_TRAVEL_CASH_BACK_REWARDS_SELECT],
    name: 'Upgrade Travel Rewards Select Card',
    shortName: 'Travel Rewards Select',
    article: 'an',
    legalDefinition: CARD.DEFAULT
  },
  LENDING_TREE: {
    codes: [LENDING_TREE_GROW],
    name: 'LendingTree Win Card',
    shortName: 'LendingTree Win',
    article: 'a'
  },
  SELECT_CARD: {
    codes: [CARD_CREDIT_BUILDER],
    name: 'Upgrade Select card',
    shortName: 'Select',
    article: 'an',
    legalDefinition: CARD.DEFAULT
  },
  MYFIVE_CASH_REWARDS_CARD: {
    codes: [CARD_MYFIVE_CASH_REWARDS],
    name: 'Upgrade MyFive Cash Rewards Card',
    shortName: 'MyFive Cash Rewards',
    article: 'an',
    legalDefinition: CARD.DEFAULT
  },
  MYFIVE_CASH_REWARDS_CARD_WITH_ANNUAL_FEE: {
    codes: [CARD_MYFIVE_CASH_REWARDS_WITH_ANNUAL_FEE],
    name: 'Upgrade MyFive Cash Rewards Select Card',
    shortName: 'MyFive Cash Rewards Select',
    article: 'an',
    legalDefinition: CARD.DEFAULT
  },
  MYFIVE_CASH_REWARDS_CARD_V2: {
    codes: [CARD_MYFIVE_CASH_REWARDS_V2],
    name: 'Upgrade MyFive Cash Rewards Card',
    shortName: 'MyFive Cash Rewards',
    article: 'an',
    legalDefinition: CARD.DEFAULT
  },
  MYFIVE_CASH_REWARDS_CARD_V2_WITH_ANNUAL_FEE: {
    codes: [CARD_MYFIVE_CASH_REWARDS_V2_WITH_ANNUAL_FEE],
    name: 'Upgrade MyFive Cash Rewards Select Card',
    shortName: 'MyFive Cash Rewards Select',
    article: 'an',
    legalDefinition: CARD.DEFAULT
  },
  CASH_REWARDS_WITH_AUTOPAY_CARD: {
    codes: [CARD_CASH_REWARDS_WITH_AUTOPAY],
    name: 'Upgrade Cash Rewards Card',
    shortName: 'Cash Rewards',
    article: 'an',
    legalDefinition: CARD.DEFAULT
  },
  CASH_REWARDS_WITH_AUTOPAY_CARD_WITH_ANNUAL_FEE: {
    codes: [CARD_CASH_REWARDS_WITH_AUTOPAY_WITH_ANNUAL_FEE],
    name: 'Upgrade Cash Rewards Select Card',
    shortName: 'Cash Rewards Select',
    article: 'an',
    legalDefinition: CARD.DEFAULT
  },
  DEFAULT: {
    name: 'Upgrade Card',
    shortName: 'Upgrade Card',
    article: 'an'
  }
};
const findCardDefinition = code => {
  const cardDefinitionKey = Object.keys(CARD_DEFINITION).find(key => CARD_DEFINITION[key].codes?.includes(code));
  return CARD_DEFINITION[cardDefinitionKey] || CARD_DEFINITION.DEFAULT;
};
const formatCardName = ({
  code,
  withArticle = false,
  displayLegalName = true,
  displayShortName = false
}) => {
  let cardDefinition = findCardDefinition(code);
  if (displayLegalName && cardDefinition.legalDefinition) cardDefinition = CARD_DEFINITION[cardDefinition.legalDefinition];
  if (displayShortName) {
    return cardDefinition.shortName;
  }
  return `${withArticle ? `${cardDefinition.article} ` : ''}${cardDefinition.name}`;
};
export default formatCardName;